// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductGrid_container__a8srT","productGrid":"ProductGrid_productGrid___X7Tn"};